/*! @pentacode/ui v0.1.0 */
import { t as e } from "./decorateMetadata-BhwOl-pv.js";
import { t } from "./decorate-DHgd5sZx.js";
import { t as n } from "./css-build-DICbZE45.js";
import { c as r, l as i, t as a } from "./chunk.UEBQI7VV-cl3cPog2.js";
import { a as o, c as s, i as c, l, n as u, o as d, r as f, s as p, t as m, u as h } from "./chunk.PZAN6FPN-NvFrxejO.js";
import { t as g } from "./chunk.F25QOBDY-D6vAKIyo.js";
import { css as _, html as v } from "lit";
import { customElement as y, property as b, query as x, state as S } from "lit/decorators.js";
import { classMap as C } from "lit/directives/class-map.js";
//#region ../../node_modules/.pnpm/@awesome.me+webawesome@3.14.0_@floating-ui+utils@0.2.11_@types+node@24.19.2_@types+react@19.2.17/node_modules/@awesome.me/webawesome/dist/chunks/chunk.DJLBC7Q4.js
var w = _`
  :host {
    --max-width: 30ch;

    /** These styles are added so we don't interfere in the DOM. */
    display: inline-block;
    position: absolute;

    /** Defaults for inherited CSS properties */
    color: var(--wa-tooltip-content-color);
    font-size: var(--wa-tooltip-font-size);
    line-height: var(--wa-tooltip-line-height);
    text-align: start;
    white-space: normal;
  }

  .tooltip {
    --arrow-size: var(--wa-tooltip-arrow-size);
    --arrow-color: var(--wa-tooltip-background-color);
  }

  .tooltip::part(popup) {
    z-index: 1000;
  }

  .tooltip[placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .tooltip[placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .tooltip[placement^='left']::part(popup) {
    transform-origin: right;
  }

  .tooltip[placement^='right']::part(popup) {
    transform-origin: left;
  }

  .body {
    display: block;
    width: max-content;
    max-width: var(--max-width);
    border-radius: var(--wa-tooltip-border-radius);
    background-color: var(--wa-tooltip-background-color);
    border: var(--wa-tooltip-border-width) var(--wa-tooltip-border-style) var(--wa-tooltip-border-color);
    padding: 0.25em 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }

  .tooltip {
    --popup-border-width: var(--wa-tooltip-border-width);

    /* Inset box-shadow, not a border: Safari seams a clip-path edge that runs along a border. */
    &::part(arrow) {
      box-shadow: inset calc(-1 * var(--wa-tooltip-border-width)) calc(-1 * var(--wa-tooltip-border-width)) 0 0
        var(--wa-tooltip-border-color);
    }
  }
`;
//#endregion
//#region ../../node_modules/.pnpm/@awesome.me+webawesome@3.14.0_@floating-ui+utils@0.2.11_@types+node@24.19.2_@types+react@19.2.17/node_modules/@awesome.me/webawesome/dist/chunks/chunk.6RPNM7SD.js
function T(e, t) {
	for (; t;) {
		if (t === e) return !0;
		t = t instanceof Element && t.assignedSlot ? t.assignedSlot : t.parentNode ? t.parentNode : t instanceof ShadowRoot ? t.host : null;
	}
	return !1;
}
var E = class extends r {
	constructor() {
		super(...arguments), this.dismissedByPress = !1, this.placement = "top", this.disabled = !1, this.distance = 8, this.open = !1, this.skidding = 0, this.showDelay = 150, this.hideDelay = 0, this.trigger = "hover focus", this.withoutArrow = !1, this.for = null, this.anchor = null, this.eventController = new AbortController(), this.handleBlur = () => {
			this.dismissedByPress = !1, this.hasTrigger("focus") && this.hide();
		}, this.handleClick = () => {
			if (this.hasTrigger("click")) {
				this.open ? this.hide() : this.show();
				return;
			}
			this.hasTrigger("manual") || this.lightDismiss();
		}, this.handleFocus = () => {
			this.dismissedByPress || this.hasTrigger("focus") && this.show();
		}, this.handleMouseDown = () => {
			this.hasTrigger("click") || this.hasTrigger("manual") || this.lightDismiss();
		}, this.handleDocumentKeyDown = (e) => {
			this.hasTrigger("manual") || e.key === "Escape" && this.open && c(this) && (e.preventDefault(), e.stopPropagation(), this.hide());
		}, this.handleDocumentClick = (e) => {
			this.hasTrigger("manual") || this.anchor && e.composedPath().includes(this.anchor) || this.hide();
		}, this.handleMouseOver = () => {
			this.dismissedByPress || this.hasTrigger("hover") && (clearTimeout(this.hoverTimeout), this.hoverTimeout = window.setTimeout(() => this.show(), this.showDelay));
		}, this.handleMouseOut = (e) => {
			let t = e.relatedTarget, n = !!(t && this.anchor && T(this.anchor, t)), r = !!(t && T(this, t));
			n || r || (this.dismissedByPress = !1, this.hasTrigger("hover") && (clearTimeout(this.hoverTimeout), this.hoverTimeout = window.setTimeout(() => {
				this.hide();
			}, this.hideDelay)));
		};
	}
	connectedCallback() {
		super.connectedCallback(), typeof document < "u" && (this.eventController.signal.aborted && (this.eventController = new AbortController()), this.addEventListener("mouseout", this.handleMouseOut), this.dismissedByPress = !1, this.open && (this.open = !1, this.updateComplete.then(() => {
			this.open = !0;
		})), this.id ||= f("wa-tooltip-"), this.for && this.anchor ? (this.anchor = null, this.handleForChange()) : this.for && this.handleForChange());
	}
	disconnectedCallback() {
		super.disconnectedCallback(), document.removeEventListener("keydown", this.handleDocumentKeyDown), document.removeEventListener("click", this.handleDocumentClick), d(this), this.eventController.abort(), this.anchor && this.removeFromAriaLabelledBy(this.anchor, this.id);
	}
	firstUpdated(e) {
		this.body.hidden = !this.open, this.open && (this.popup.active = !0, this.popup.reposition()), super.firstUpdated(e);
	}
	lightDismiss() {
		clearTimeout(this.hoverTimeout), this.dismissedByPress = !0, this.hide();
	}
	hasTrigger(e) {
		return this.trigger.split(" ").includes(e);
	}
	addToAriaLabelledBy(e, t) {
		let n = (e.getAttribute("aria-labelledby") || "").split(/\s+/).filter(Boolean);
		n.includes(t) || (n.push(t), e.setAttribute("aria-labelledby", n.join(" ")));
	}
	removeFromAriaLabelledBy(e, t) {
		let n = (e.getAttribute("aria-labelledby") || "").split(/\s+/).filter(Boolean).filter((e) => e !== t);
		n.length > 0 ? e.setAttribute("aria-labelledby", n.join(" ")) : e.removeAttribute("aria-labelledby");
	}
	async handleOpenChange() {
		if (this.open) {
			if (this.disabled) return;
			let e = new h();
			if (this.dispatchEvent(e), e.defaultPrevented) {
				this.open = !1;
				return;
			}
			this.hasTrigger("manual") || (document.addEventListener("keydown", this.handleDocumentKeyDown, { signal: this.eventController.signal }), document.addEventListener("click", this.handleDocumentClick, { signal: this.eventController.signal }), o(this)), this.body.hidden = !1, this.popup.active = !0, await u(this.popup.popup, "show-with-scale"), this.popup.reposition(), this.dispatchEvent(new p());
		} else {
			let e = new l();
			if (this.dispatchEvent(e), e.defaultPrevented) {
				this.open = !0;
				return;
			}
			document.removeEventListener("keydown", this.handleDocumentKeyDown), document.removeEventListener("click", this.handleDocumentClick), d(this), await u(this.popup.popup, "hide-with-scale"), this.popup.active = !1, this.body.hidden = !0, this.dispatchEvent(new s());
		}
	}
	handleForChange() {
		let e = this.getRootNode?.();
		if (!e) return;
		let t = this.for ? e.getElementById?.(this.for) : null, n = this.anchor;
		if (t === n) return;
		this.dismissedByPress = !1;
		let { signal: r } = this.eventController;
		t && (this.addToAriaLabelledBy(t, this.id), t.addEventListener("blur", this.handleBlur, {
			capture: !0,
			signal: r
		}), t.addEventListener("focus", this.handleFocus, {
			capture: !0,
			signal: r
		}), t.addEventListener("click", this.handleClick, { signal: r }), t.addEventListener("mousedown", this.handleMouseDown, { signal: r }), t.addEventListener("mouseover", this.handleMouseOver, { signal: r }), t.addEventListener("mouseout", this.handleMouseOut, { signal: r })), n && (this.removeFromAriaLabelledBy(n, this.id), n.removeEventListener("blur", this.handleBlur, { capture: !0 }), n.removeEventListener("focus", this.handleFocus, { capture: !0 }), n.removeEventListener("click", this.handleClick), n.removeEventListener("mousedown", this.handleMouseDown), n.removeEventListener("mouseover", this.handleMouseOver), n.removeEventListener("mouseout", this.handleMouseOut)), this.anchor = t;
	}
	async handleOptionsChange() {
		this.hasUpdated && (await this.updateComplete, this.popup.reposition());
	}
	handleDisabledChange() {
		this.disabled && this.open && this.hide();
	}
	async show() {
		if (!this.open) return this.open = !0, g(this, "wa-after-show");
	}
	async hide() {
		if (this.open) return this.open = !1, g(this, "wa-after-hide");
	}
	render() {
		return v`
      <wa-popup
        part="base tooltip"
        exportparts="
          popup:base__popup,
          arrow:base__arrow
        "
        class=${C({
			tooltip: !0,
			"tooltip-open": this.open
		})}
        placement=${this.placement}
        distance=${this.distance}
        skidding=${this.skidding}
        flip
        shift
        ?arrow=${!this.withoutArrow}
        hover-bridge
        .anchor=${this.anchor}
      >
        <div part="body" class="body">
          <slot></slot>
        </div>
      </wa-popup>
    `;
	}
};
E.css = w, E.dependencies = { "wa-popup": a }, i([x("slot:not([name])")], E.prototype, "defaultSlot", 2), i([x(".body")], E.prototype, "body", 2), i([x("wa-popup")], E.prototype, "popup", 2), i([b()], E.prototype, "placement", 2), i([b({
	type: Boolean,
	reflect: !0
})], E.prototype, "disabled", 2), i([b({ type: Number })], E.prototype, "distance", 2), i([b({
	type: Boolean,
	reflect: !0
})], E.prototype, "open", 2), i([b({ type: Number })], E.prototype, "skidding", 2), i([b({
	attribute: "show-delay",
	type: Number
})], E.prototype, "showDelay", 2), i([b({
	attribute: "hide-delay",
	type: Number
})], E.prototype, "hideDelay", 2), i([b()], E.prototype, "trigger", 2), i([b({
	attribute: "without-arrow",
	type: Boolean,
	reflect: !0
})], E.prototype, "withoutArrow", 2), i([b()], E.prototype, "for", 2), i([S()], E.prototype, "anchor", 2), i([m("open", { waitUntilFirstUpdate: !0 })], E.prototype, "handleOpenChange", 1), i([m("for")], E.prototype, "handleForChange", 1), i([m([
	"distance",
	"placement",
	"skidding"
])], E.prototype, "handleOptionsChange", 1), i([m("disabled")], E.prototype, "handleDisabledChange", 1), E = i([y("wa-tooltip")], E);
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/tooltip/tooltip.css.js
var D = n(":host{--_tooltip-surface:var(--tooltip-surface,var(--color-highlight-bg,var(--color-bg)));--_tooltip-color:var(--tooltip-color,var(--color-highlight,var(--color-fg)));--_tooltip-border-color:var(--tooltip-border-color,var(--_tooltip-surface));--_tooltip-border-width:var(--tooltip-border-width,1px);--_tooltip-radius:var(--tooltip-radius,var(--radius-relative));--_tooltip-padding:var(--tooltip-padding,.5em);--_tooltip-shadow:var(--tooltip-shadow,0 0 3px #0003);--max-width:var(--tooltip-max-width,20em);color:var(--_tooltip-color);font-size:var(--tooltip-font-size,var(--font-size-small,.8rem));text-align:var(--tooltip-text-align,center);font-weight:400;line-height:normal}.tooltip{--arrow-size:var(--tooltip-arrow-size,.375rem);--arrow-color:var(--_tooltip-surface);--popup-border-width:var(--_tooltip-border-width);--show-duration:var(--tooltip-show-duration,.15s);--hide-duration:var(--tooltip-hide-duration,.15s)}.body{background-color:var(--_tooltip-surface);color:var(--_tooltip-color);border:var(--_tooltip-border-width) solid var(--_tooltip-border-color);border-radius:var(--_tooltip-radius);padding:var(--_tooltip-padding)}.tooltip::part(popup){border-radius:var(--_tooltip-radius);box-shadow:var(--_tooltip-shadow);filter:var(--tooltip-filter,none)}.tooltip::part(arrow){clip-path:none;z-index:-1;box-shadow:inset calc(-1 * var(--_tooltip-border-width)) calc(-1 * var(--_tooltip-border-width)) 0 0 var(--_tooltip-border-color), var(--_tooltip-shadow)}"), O = class extends E {
	static get styles() {
		return [super.styles, D];
	}
	constructor() {
		super(), this.showDelay = 0, this.addEventListener("wa-after-hide", () => {
			this.open && (this.body.hidden = !1, this.popup.active = !0);
		});
	}
};
O = t([y("ptc-ui-tooltip"), e("design:paramtypes", [])], O);
var k = O;
//#endregion
export { k as n, O as t };

//# sourceMappingURL=tooltip-2tBgcqiB.js.map